// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__mhK_q","md":"Pill_md__0p_PK","lg":"Pill_lg__a1I72","circle":"Pill_circle__j6FpU","button":"Pill_button__44Ljp"};